<template>
  <div id="app">
    <SplashScreen v-if="showSplash" @finished="showSplash = false" />

    <!-- Layout applicativo con aside (rotte autenticate) -->
    <template v-if="showShell">
      <div class="app-shell">
        <button
          class="app-mobile-toggle"
          aria-label="Apri menu"
          @click="sidebarMobileOpen = true"
        >
          <i class="fa-solid fa-bars"></i>
        </button>
        <AppSidebar
          :collapsed="sidebarCollapsed"
          :mobile-open="sidebarMobileOpen"
          @toggle-collapse="sidebarCollapsed = !sidebarCollapsed"
          @close="sidebarMobileOpen = false"
        />
        <div
          v-if="sidebarMobileOpen"
          class="app-overlay"
          @click="sidebarMobileOpen = false"
        ></div>
        <div class="app-main">
          <TopBar />
          <router-view />
          <div v-if="$route.meta.showLogo" class="developed-container">
            <span class="developed-label">Sviluppato da</span>
            <img
              src="@/assets/libero_tratto_logo.png"
              alt="Libero Tratto — logo"
              class="lt-logo"
            />
          </div>
        </div>
      </div>
    </template>

    <!-- Layout pubblico (login / guest) -->
    <template v-else>
      <TopBar />
      <router-view />
      <div
        v-if="$route.meta.showLogo"
        class="developed-container"
        :class="{ 'login-layout': $route.path === '/login' }"
      >
        <span class="developed-label">Sviluppato da</span>
        <img
          src="@/assets/libero_tratto_logo.png"
          alt="Libero Tratto — logo"
          class="lt-logo"
        />
      </div>
    </template>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue"; // Percorso del componente TopBar
import SplashScreen from "@/components/SplashScreen.vue";
import AppSidebar from "@/components/AppSidebar.vue";
// import { ref, watch } from "vue";
// import { useRoute } from "vue-router";

// Splash screen iniziale: per disattivarlo in sviluppo mettere a false.
const SPLASH_ENABLED = true;

export default {
  name: "App",
  components: {
    TopBar,
    SplashScreen,
    AppSidebar,
  },
  data() {
    return {
      // Mostra lo splash una sola volta per sessione del browser.
      showSplash:
        SPLASH_ENABLED &&
        typeof sessionStorage !== "undefined" &&
        !sessionStorage.getItem("villaSplashShown"),
      sidebarCollapsed: false,
      sidebarMobileOpen: false,
    };
  },
  computed: {
    // Mostra il layout con aside solo sulle rotte autenticate (non login/guest).
    showShell() {
      return !this.$route.matched.some((r) => r.meta && r.meta.requiresGuest);
    },
  },
  watch: {
    // Chiudi il drawer mobile a ogni cambio rotta.
    "$route.fullPath"() {
      this.sidebarMobileOpen = false;
    },
  },
  mounted() {
    if (this.showSplash) {
      try {
        sessionStorage.setItem("villaSplashShown", "1");
      } catch {
        // sessionStorage non disponibile: lo splash resta comunque temporaneo
      }
    }
  },
  // setup() {
  //   const route = useRoute();
  //   const breadcrumbs = ref([]);

  //   const generateBreadcrumbs = (currentRoute) => {
  //     return currentRoute.matched.map((matchedRoute) => ({
  //       name: matchedRoute.meta.breadcrumb || matchedRoute.name, // Usa il breadcrumb dal meta o il nome della rotta
  //       path: matchedRoute.path,
  //     }));
  //   };

  //   // Inizializza i breadcrumbs
  //   breadcrumbs.value = generateBreadcrumbs(route);

  //   // Osserva i cambiamenti della route e aggiorna i breadcrumbs
  //   watch(
  //     () => route.path,
  //     () => {
  //       breadcrumbs.value = generateBreadcrumbs(route);
  //     }
  //   );

  //   return { breadcrumbs };
  // },
};
</script>

<style src="@/css/App.css"></style>
